import {
    faArrowRight, faArrowLeft, faArrowUp, faArrowDown,
    faChevronRight, faChevronLeft, faChevronUp, faChevronDown
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { parseMarginPadding, parseResult } from '../controlUtils';
import { ef } from "../effectUtils";

export function displayArrowUtil(obj, entryPoint){

    const content = JSON.parse(obj.Content);
    const display = content.Display;
    const direction = content.Direction;
    const theme = content.Theme;
    const size = content.Size;
    const label = content.Label;
    const marginPadding = content.MarginPadding;

    const mp = parseMarginPadding(marginPadding);

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let arSz = 0; let lbSz = 0; let zoom = 0;
    if(size == "small"){ arSz=20; lbSz=12}
    else if(size == "medium"){ arSz=30; lbSz=13 }
    else if(size == "large"){ arSz=40; lbSz=14 }
    else if(size == "xlarge"){ arSz=50; lbSz=16 }
    else if(size == "xxlarge"){ arSz=65; lbSz=18 }

    if(entryPoint == "presentation" && obj.Presentation != ""){
        const ptn = JSON.parse(obj.Presentation);
        if(ptn.TitleSize != "") { lbSz = parseInt(ptn.TitleSize) }
        if(ptn.TextSize != "") { arSz = parseInt(ptn.TextSize) }
        if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
    }

    const styles = {
        wrap:{
            display: 'flex',
            flex: 1,
            zoom: `${zoom}%`,
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: mp.marginTop,
            marginRight: mp.marginRight,
            marginBottom: mp.marginBottom,
            marginLeft: mp.marginLeft,
            paddingTop: mp.paddingTop,
            paddingRight: mp.paddingRight,
            paddingBottom: mp.paddingBottom,
            paddingLeft: mp.paddingLeft,
        },
        arrow:{
            plain:{
                flex: 1,
                color: (bgColor == "#fff")? '#ccc': bgColor,
                fontSize: arSz,
            },
            circle:{
                flex: 1,
                background: bgColor,
                color: txtColor,
                width: arSz,
                height: arSz,
                padding: 10,
                borderRadius: '100%',
                fontSize: arSz,
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            },
            square:{
                flex: 1,
                background: bgColor,
                color: txtColor,
                width: arSz,
                height: arSz,
                padding: 10,
                borderRadius: 5,
                fontSize: arSz,
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            },
        },
        label:{
            color: (bgColor == "#fff")? '#ccc': bgColor,
            marginBottom: 10,
            fontSize: lbSz
        },
        space:{
            marginBottom:10
        }
    }

    let arrow = <></>;

    switch(direction){
        case 'right':
            arrow = rightArrow(display, styles.arrow);
            break;
        case 'left':
            arrow = leftArrow(display, styles.arrow);
            break;
        case 'up':
            arrow = upArrow(display, styles.arrow);
            break;
        case 'down':
            arrow = downArrow(display, styles.arrow);
            break;
        case 'left-right':
            arrow = <div style={styles.wrap}>
                    {leftArrow(display, styles.arrow)}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {rightArrow(display, styles.arrow)}
                </div>
            break;
        case 'up-down':
            arrow = <div style={styles.wrap}>
                    <div>
                        {upArrow(display, styles.arrow)}
                        <div style={styles.space}></div>
                        {downArrow(display, styles.arrow)}
                    </div>
                </div>
            break;
    }

    const elem = (
        <div style={styles.wrap}>
            <div style={{textAlign: 'center'}}>
                <div style={styles.label}>{label}</div>
                {arrow}
            </div>
        </div>
    )

    return parseResult(elem, obj, entryPoint);

}

function rightArrow(display, style){
    if(display == "arrow"){
        return <FontAwesomeIcon icon = {faArrowRight} style={style.plain} />
    }
    else if(display == "chevron"){
        return <FontAwesomeIcon icon = {faChevronRight} style={style.plain} />
    }
    else if(display == "circle-arrow"){
        return  <FontAwesomeIcon icon = {faArrowRight} style={style.circle} />
    }
    else if(display == "circle-chevron"){
        return <FontAwesomeIcon icon = {faChevronRight} style={style.circle} />
    }
    else if(display == "square-arrow"){
        return <FontAwesomeIcon icon = {faArrowRight} style={style.square} />
    }
    else if(display == "square-chevron"){
        return <FontAwesomeIcon icon = {faChevronRight} style={style.square} />
    }
}

function leftArrow(display, style){
    if(display == "arrow"){
        return <FontAwesomeIcon icon = {faArrowLeft} style={style.plain} />
    }
    else if(display == "chevron"){
        return <FontAwesomeIcon icon = {faChevronLeft} style={style.plain} />
    } 
    else if(display == "circle-arrow"){
        return <FontAwesomeIcon icon = {faArrowLeft} style={style.circle} />
    }
    else if(display == "circle-chevron"){
        return <FontAwesomeIcon icon = {faChevronLeft} style={style.circle} />
    }
    else if(display == "square-arrow"){
        return <FontAwesomeIcon icon = {faArrowLeft} style={style.square} />
    }
    else if(display == "square-chevron"){
        return <FontAwesomeIcon icon = {faChevronLeft} style={style.square} />
    } 
}

function upArrow(display, style){
    if(display == "arrow"){
        return <FontAwesomeIcon icon = {faArrowUp} style={style.plain} />
    }
    else if(display == "chevron"){
        return <FontAwesomeIcon icon = {faChevronUp} style={style.plain} />
    } 
    else if(display == "circle-arrow"){
        return <FontAwesomeIcon icon = {faArrowUp} style={style.circle} />
    }
    else if(display == "circle-chevron"){
        return <FontAwesomeIcon icon = {faChevronUp} style={style.circle} />
    } 
    else if(display == "square-arrow"){
        return <FontAwesomeIcon icon = {faArrowUp} style={style.square} />
    }
    else if(display == "square-chevron"){
        return <FontAwesomeIcon icon = {faChevronUp} style={style.square} />
    } 
}

function downArrow(display, style){
    if(display == "arrow"){
        return <FontAwesomeIcon icon = {faArrowDown} style={style.plain} />
    }
    else if(display == "chevron"){
        return <FontAwesomeIcon icon = {faChevronDown} style={style.plain} />
    } 
    else if(display == "circle-arrow"){
        return <FontAwesomeIcon icon = {faArrowDown} style={style.circle} />
    }
    else if(display == "circle-chevron"){
        return <FontAwesomeIcon icon = {faChevronDown} style={style.circle} />
    } 
    else if(display == "square-arrow"){
        return <FontAwesomeIcon icon = {faArrowDown} style={style.square} />
    }
    else if(display == "square-chevron"){
        return <FontAwesomeIcon icon = {faChevronDown} style={style.square} />
    } 
}